dmx.Component('api-action', { extends: 'fetch' });
